var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('transition',{attrs:{"appear":"","appear-class":"app-appear","appear-active-class":"app-appear-active"}},[_c('div',{staticClass:"container mt-4 mb5"},[_c('h3',{staticClass:"lesson-subheading"},[_vm._v("Addition")]),_c('hr',{staticClass:"subheading-separator"}),_c('div',{staticClass:"row",staticStyle:{"max-width":"100%"}},[_c('div',{staticClass:"col-12 col-md-6 app--lesson-left",staticStyle:{"max-width":"50%"}},[_c('div',{staticStyle:{"text-align":"left","max-width":"70%"}},[_c('h5',[_vm._v("Choose the grid size")]),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],staticStyle:{"width":"10vw","font-size":"1.5vw"},attrs:{"id":"gridSize"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selected=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.generateTable()}]}},_vm._l((_vm.options),function(option){return _c('option',{key:option.value,domProps:{"value":option.value}},[_vm._v("\n                "+_vm._s(option.text)+"\n              ")])}),0),_c('br'),_c('br'),_c('h5',[_vm._v("Choose the difficulty level")]),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected1),expression:"selected1"}],staticStyle:{"width":"10vw","font-size":"1.5vw"},attrs:{"id":"select1"},on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.selected1=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){return _vm.generateTable()}]}},_vm._l((_vm.options1),function(s1){return _c('option',{key:s1.value,domProps:{"value":s1.value}},[_vm._v("\n                "+_vm._s(s1.text)+"\n              ")])}),0),_c('br'),_c('br'),_c('input',{attrs:{"type":"checkbox","name":"myRadio","id":"ccc"},on:{"change":function($event){return _vm.a()}}}),_vm._v("\n            Graph time taken       \n            "),(_vm.resetNow === false)?_c('button',{staticClass:"btn btn-outline-success",staticStyle:{"margin":"auto"},attrs:{"id":"ok"},on:{"click":function($event){return _vm.check()}}},[_vm._v("\n              Check\n            ")]):_vm._e(),(_vm.resetNow === true)?_c('button',{staticClass:"btn btn-outline-success",staticStyle:{"margin":"auto"},attrs:{"id":"rs"},on:{"click":function($event){return _vm.reset()}}},[_vm._v("\n              Reset\n            ")]):_vm._e(),_c('br'),_c('br'),_c('h5',{staticClass:"mb-3"},[_vm._v("Complete this addition grid")]),(_vm.alertMessage)?_c('div',{class:_vm.isAlert ? 'alert alert-success' : 'alert alert-danger'},[_vm._v("\n              "+_vm._s(_vm.alertMessage)+"\n            ")]):_vm._e(),_c('table',{staticStyle:{"color":"#004488","text-align":"center","vertical-align":"center","visibility":"visible","border":"#7f8c8d solid","background":"white"},attrs:{"id":"tableAdd"}},_vm._l((_vm.selected + 1),function(i){return _c('tr',{key:i},_vm._l((_vm.selected + 1),function(j){return _c('td',{key:j,style:((j === 1 && i !== 1) || (i === 1 && j !== 1)
                      ? 'width: 6vw; height: 5vw; background: rgba(165, 220, 255, 1)'
                      : 'width: 6vw; height: 5vw;')},[(i === 1 && j === 1)?_c('b',[_c('span',{staticStyle:{"color":"black","font-size":"2rem"}},[_vm._v("+")])]):(
                      i === 1 &&
                        j === _vm.c[0] + 1 &&
                        _vm.arrSimpleOne[j - 2] > 0 &&
                        _vm.randomIndex === 'r'
                    )?_c('b',[_vm._v(_vm._s(_vm.arrSimpleThree[j - 2] === 0
                        ? _vm.arrSimpleOne[j - 2]
                        : _vm.arrSimpleThree[j - 2] === 1
                        ? "x+" + _vm.arrSimpleOne[j - 2]
                        : _vm.arrSimpleThree[j - 2] === -1
                        ? "-x+" + _vm.arrSimpleOne[j - 2]
                        : _vm.arrSimpleThree[j - 2] + "x+" + _vm.arrSimpleOne[j - 2]))]):(
                      i === 1 &&
                        j === _vm.c[0] + 1 &&
                        _vm.arrSimpleOne[j - 2] === 0 &&
                        _vm.randomIndex === 'r'
                    )?_c('b',[_vm._v(_vm._s(_vm.arrSimpleThree[j - 2] === 0
                        ? 0
                        : _vm.arrSimpleThree[j - 2] === 1
                        ? "x"
                        : _vm.arrSimpleThree[j - 2] === -1
                        ? "-x"
                        : _vm.arrSimpleThree[j - 2] + "x"))]):(
                      i === 1 &&
                        j === _vm.c[0] + 1 &&
                        _vm.arrSimpleOne[j - 2] < 0 &&
                        _vm.randomIndex === 'r'
                    )?_c('b',[_vm._v(_vm._s(_vm.arrSimpleThree[j - 2] === 0
                        ? _vm.arrSimpleOne[j - 2]
                        : _vm.arrSimpleThree[j - 2] === 1
                        ? "x" + _vm.arrSimpleOne[j - 2]
                        : _vm.arrSimpleThree[j - 2] === -1
                        ? "-x" + _vm.arrSimpleOne[j - 2]
                        : _vm.arrSimpleThree[j - 2] + "x" + _vm.arrSimpleOne[j - 2])+"\n                  ")]):(
                      j === 1 &&
                        i === _vm.r[0] + 1 &&
                        _vm.arrSimpleTwo[i - 2] > 0 &&
                        _vm.randomIndex === 'c'
                    )?_c('b',[_vm._v(_vm._s(_vm.arrSimpleFour[i - 2] === 0
                        ? _vm.arrSimpleTwo[i - 2]
                        : _vm.arrSimpleFour[i - 2] === 1
                        ? "x+" + _vm.arrSimpleTwo[i - 2]
                        : _vm.arrSimpleFour[i - 2] === -1
                        ? "-x+" + _vm.arrSimpleTwo[i - 2]
                        : _vm.arrSimpleFour[i - 2] + "x+" + _vm.arrSimpleTwo[i - 2]))]):(
                      j === 1 &&
                        i === _vm.r[0] + 1 &&
                        _vm.arrSimpleTwo[i - 2] === 0 &&
                        _vm.randomIndex === 'c'
                    )?_c('b',[_vm._v(_vm._s(_vm.arrSimpleFour[i - 2] === 0
                        ? 0
                        : _vm.arrSimpleFour[i - 2] === 1
                        ? "x"
                        : _vm.arrSimpleFour[i - 2] === -1
                        ? "-x"
                        : _vm.arrSimpleFour[i - 2] + "x"))]):(
                      j === 1 &&
                        i === _vm.r[0] + 1 &&
                        _vm.arrSimpleTwo[i - 2] < 0 &&
                        _vm.randomIndex === 'c'
                    )?_c('b',[_vm._v(_vm._s(_vm.arrSimpleFour[i - 2] === 0
                        ? _vm.arrSimpleTwo[i - 2]
                        : _vm.arrSimpleFour[i - 2] === 1
                        ? "x" + _vm.arrSimpleTwo[i - 2]
                        : _vm.arrSimpleFour[i - 2] === -1
                        ? "-x" + _vm.arrSimpleTwo[i - 2]
                        : _vm.arrSimpleFour[i - 2] + "x" + _vm.arrSimpleTwo[i - 2]))]):(
                      i === _vm.r[0] + 1 &&
                        j === _vm.c[0] + 1 &&
                        _vm.arrSimpleOne[j - 2] + _vm.arrSimpleTwo[i - 2] > 0
                    )?_c('b',[_vm._v(_vm._s(_vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === 0
                        ? _vm.arrSimpleTwo[i - 2] + _vm.arrSimpleOne[j - 2]
                        : _vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === 1
                        ? "x+" + (_vm.arrSimpleTwo[i - 2] + _vm.arrSimpleOne[j - 2])
                        : _vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === -1
                        ? "-x+" + (_vm.arrSimpleTwo[i - 2] + _vm.arrSimpleOne[j - 2])
                        : _vm.arrSimpleThree[j - 2] +
                          _vm.arrSimpleFour[i - 2] +
                          "x+" +
                          (_vm.arrSimpleTwo[i - 2] + _vm.arrSimpleOne[j - 2]))+"\n                  ")]):(
                      i === _vm.r[0] + 1 &&
                        j === _vm.c[0] + 1 &&
                        _vm.arrSimpleOne[j - 2] + _vm.arrSimpleTwo[i - 2] === 0
                    )?_c('b',[_vm._v(_vm._s(_vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === 0
                        ? 0
                        : _vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === 1
                        ? "x"
                        : _vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === -1
                        ? "-x"
                        : _vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] + "x"))]):(
                      i === _vm.r[0] + 1 &&
                        j === _vm.c[0] + 1 &&
                        _vm.arrSimpleOne[j - 2] + _vm.arrSimpleTwo[i - 2] < 0
                    )?_c('b',[_vm._v(_vm._s(_vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === 0
                        ? _vm.arrSimpleOne[j - 2] + _vm.arrSimpleTwo[i - 2]
                        : _vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === 1
                        ? "x" + (_vm.arrSimpleOne[j - 2] + _vm.arrSimpleTwo[i - 2])
                        : _vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === -1
                        ? "-x" + (_vm.arrSimpleOne[j - 2] + _vm.arrSimpleTwo[i - 2])
                        : _vm.arrSimpleThree[j - 2] +
                          _vm.arrSimpleFour[i - 2] +
                          "x" +
                          (_vm.arrSimpleOne[j - 2] + _vm.arrSimpleTwo[i - 2])))]):(
                      i === _vm.r[0] + 1 &&
                        j === _vm.c[1] + 1 &&
                        _vm.arrSimpleOne[j - 2] + _vm.arrSimpleTwo[i - 2] > 0
                    )?_c('b',[_vm._v(_vm._s(_vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === 0
                        ? _vm.arrSimpleTwo[i - 2] + _vm.arrSimpleOne[j - 2]
                        : _vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === 1
                        ? "x+" + (_vm.arrSimpleTwo[i - 2] + _vm.arrSimpleOne[j - 2])
                        : _vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === -1
                        ? "-x+" + (_vm.arrSimpleTwo[i - 2] + _vm.arrSimpleOne[j - 2])
                        : _vm.arrSimpleThree[j - 2] +
                          _vm.arrSimpleFour[i - 2] +
                          "x+" +
                          (_vm.arrSimpleTwo[i - 2] + _vm.arrSimpleOne[j - 2])))]):(
                      i === _vm.r[0] + 1 &&
                        j === _vm.c[1] + 1 &&
                        _vm.arrSimpleOne[j - 2] + _vm.arrSimpleTwo[i - 2] === 0
                    )?_c('b',[_vm._v(_vm._s(_vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === 0
                        ? 0
                        : _vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === 1
                        ? "x"
                        : _vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === -1
                        ? "-x"
                        : _vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] + "x"))]):(
                      i === _vm.r[0] + 1 &&
                        j === _vm.c[1] + 1 &&
                        _vm.arrSimpleOne[j - 2] + _vm.arrSimpleTwo[i - 2] < 0
                    )?_c('b',[_vm._v(_vm._s(_vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === 0
                        ? _vm.arrSimpleOne[j - 2] + _vm.arrSimpleTwo[i - 2]
                        : _vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === 1
                        ? "x" + (_vm.arrSimpleOne[j - 2] + _vm.arrSimpleTwo[i - 2])
                        : _vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === -1
                        ? "-x" + (_vm.arrSimpleOne[j - 2] + _vm.arrSimpleTwo[i - 2])
                        : _vm.arrSimpleThree[j - 2] +
                          _vm.arrSimpleFour[i - 2] +
                          "x" +
                          (_vm.arrSimpleOne[j - 2] + _vm.arrSimpleTwo[i - 2])))]):(
                      i === _vm.r[1] + 1 &&
                        j === _vm.c[1] + 1 &&
                        _vm.arrSimpleOne[j - 2] + _vm.arrSimpleTwo[i - 2] > 0
                    )?_c('b',[_vm._v(_vm._s(_vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === 0
                        ? _vm.arrSimpleTwo[i - 2] + _vm.arrSimpleOne[j - 2]
                        : _vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === 1
                        ? "x+" + (_vm.arrSimpleTwo[i - 2] + _vm.arrSimpleOne[j - 2])
                        : _vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === -1
                        ? "-x+" + (_vm.arrSimpleTwo[i - 2] + _vm.arrSimpleOne[j - 2])
                        : _vm.arrSimpleThree[j - 2] +
                          _vm.arrSimpleFour[i - 2] +
                          "x+" +
                          (_vm.arrSimpleTwo[i - 2] + _vm.arrSimpleOne[j - 2])))]):(
                      i === _vm.r[1] + 1 &&
                        j === _vm.c[1] + 1 &&
                        _vm.arrSimpleOne[j - 2] + _vm.arrSimpleTwo[i - 2] === 0
                    )?_c('b',[_vm._v(_vm._s(_vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === 0
                        ? 0
                        : _vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === 1
                        ? "x"
                        : _vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === -1
                        ? "-x"
                        : _vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] + "x"))]):(
                      i === _vm.r[1] + 1 &&
                        j === _vm.c[1] + 1 &&
                        _vm.arrSimpleOne[j - 2] + _vm.arrSimpleTwo[i - 2] < 0
                    )?_c('b',[_vm._v(_vm._s(_vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === 0
                        ? _vm.arrSimpleOne[j - 2] + _vm.arrSimpleTwo[i - 2]
                        : _vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === 1
                        ? "x" + (_vm.arrSimpleOne[j - 2] + _vm.arrSimpleTwo[i - 2])
                        : _vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === -1
                        ? "-x" + (_vm.arrSimpleOne[j - 2] + _vm.arrSimpleTwo[i - 2])
                        : _vm.arrSimpleThree[j - 2] +
                          _vm.arrSimpleFour[i - 2] +
                          "x" +
                          (_vm.arrSimpleOne[j - 2] + _vm.arrSimpleTwo[i - 2])))]):(
                      i === _vm.r[1] + 1 &&
                        j === _vm.c[2] + 1 &&
                        _vm.arrSimpleOne[j - 2] + _vm.arrSimpleTwo[i - 2] > 0
                    )?_c('b',[_vm._v(_vm._s(_vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === 0
                        ? _vm.arrSimpleTwo[i - 2] + _vm.arrSimpleOne[j - 2]
                        : _vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === 1
                        ? "x+" + (_vm.arrSimpleTwo[i - 2] + _vm.arrSimpleOne[j - 2])
                        : _vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === -1
                        ? "-x+" + (_vm.arrSimpleTwo[i - 2] + _vm.arrSimpleOne[j - 2])
                        : _vm.arrSimpleThree[j - 2] +
                          _vm.arrSimpleFour[i - 2] +
                          "x+" +
                          (_vm.arrSimpleTwo[i - 2] + _vm.arrSimpleOne[j - 2])))]):(
                      i === _vm.r[1] + 1 &&
                        j === _vm.c[2] + 1 &&
                        _vm.arrSimpleOne[j - 2] + _vm.arrSimpleTwo[i - 2] === 0
                    )?_c('b',[_vm._v(_vm._s(_vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === 0
                        ? 0
                        : _vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === 1
                        ? "x"
                        : _vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === -1
                        ? "-x"
                        : _vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] + "x"))]):(
                      i === _vm.r[1] + 1 &&
                        j === _vm.c[2] + 1 &&
                        _vm.arrSimpleOne[j - 2] + _vm.arrSimpleTwo[i - 2] < 0
                    )?_c('b',[_vm._v(_vm._s(_vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === 0
                        ? _vm.arrSimpleOne[j - 2] + _vm.arrSimpleTwo[i - 2]
                        : _vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === 1
                        ? "x" + (_vm.arrSimpleOne[j - 2] + _vm.arrSimpleTwo[i - 2])
                        : _vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === -1
                        ? "-x" + (_vm.arrSimpleOne[j - 2] + _vm.arrSimpleTwo[i - 2])
                        : _vm.arrSimpleThree[j - 2] +
                          _vm.arrSimpleFour[i - 2] +
                          "x" +
                          (_vm.arrSimpleOne[j - 2] + _vm.arrSimpleTwo[i - 2])))]):(
                      i === _vm.r[2] + 1 &&
                        j === _vm.c[2] + 1 &&
                        _vm.arrSimpleOne[j - 2] + _vm.arrSimpleTwo[i - 2] > 0
                    )?_c('b',[_vm._v(_vm._s(_vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === 0
                        ? _vm.arrSimpleTwo[i - 2] + _vm.arrSimpleOne[j - 2]
                        : _vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === 1
                        ? "x+" + (_vm.arrSimpleTwo[i - 2] + _vm.arrSimpleOne[j - 2])
                        : _vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === -1
                        ? "-x+" + (_vm.arrSimpleTwo[i - 2] + _vm.arrSimpleOne[j - 2])
                        : _vm.arrSimpleThree[j - 2] +
                          _vm.arrSimpleFour[i - 2] +
                          "x+" +
                          (_vm.arrSimpleTwo[i - 2] + _vm.arrSimpleOne[j - 2])))]):(
                      i === _vm.r[2] + 1 &&
                        j === _vm.c[2] + 1 &&
                        _vm.arrSimpleOne[j - 2] + _vm.arrSimpleTwo[i - 2] === 0
                    )?_c('b',[_vm._v(_vm._s(_vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === 0
                        ? 0
                        : _vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === 1
                        ? "x"
                        : _vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === -1
                        ? "-x"
                        : _vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] + "x"))]):(
                      i === _vm.r[2] + 1 &&
                        j === _vm.c[2] + 1 &&
                        _vm.arrSimpleOne[j - 2] + _vm.arrSimpleTwo[i - 2] < 0
                    )?_c('b',[_vm._v(_vm._s(_vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === 0
                        ? _vm.arrSimpleOne[j - 2] + _vm.arrSimpleTwo[i - 2]
                        : _vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === 1
                        ? "x" + (_vm.arrSimpleOne[j - 2] + _vm.arrSimpleTwo[i - 2])
                        : _vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === -1
                        ? "-x" + (_vm.arrSimpleOne[j - 2] + _vm.arrSimpleTwo[i - 2])
                        : _vm.arrSimpleThree[j - 2] +
                          _vm.arrSimpleFour[i - 2] +
                          "x" +
                          (_vm.arrSimpleOne[j - 2] + _vm.arrSimpleTwo[i - 2])))]):(
                      i === _vm.r[2] + 1 &&
                        j === _vm.c[3] + 1 &&
                        _vm.arrSimpleOne[j - 2] + _vm.arrSimpleTwo[i - 2] > 0
                    )?_c('b',[_vm._v(_vm._s(_vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === 0
                        ? _vm.arrSimpleTwo[i - 2] + _vm.arrSimpleOne[j - 2]
                        : _vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === 1
                        ? "x+" + (_vm.arrSimpleTwo[i - 2] + _vm.arrSimpleOne[j - 2])
                        : _vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === -1
                        ? "-x+" + (_vm.arrSimpleTwo[i - 2] + _vm.arrSimpleOne[j - 2])
                        : _vm.arrSimpleThree[j - 2] +
                          _vm.arrSimpleFour[i - 2] +
                          "x+" +
                          (_vm.arrSimpleTwo[i - 2] + _vm.arrSimpleOne[j - 2])))]):(
                      i === _vm.r[2] + 1 &&
                        j === _vm.c[3] + 1 &&
                        _vm.arrSimpleOne[j - 2] + _vm.arrSimpleTwo[i - 2] === 0
                    )?_c('b',[_vm._v(_vm._s(_vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === 0
                        ? 0
                        : _vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === 1
                        ? "x"
                        : _vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === -1
                        ? "-x"
                        : _vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] + "x"))]):(
                      i === _vm.r[2] + 1 &&
                        j === _vm.c[3] + 1 &&
                        _vm.arrSimpleOne[j - 2] + _vm.arrSimpleTwo[i - 2] < 0
                    )?_c('b',[_vm._v(_vm._s(_vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === 0
                        ? _vm.arrSimpleOne[j - 2] + _vm.arrSimpleTwo[i - 2]
                        : _vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === 1
                        ? "x" + (_vm.arrSimpleOne[j - 2] + _vm.arrSimpleTwo[i - 2])
                        : _vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === -1
                        ? "-x" + (_vm.arrSimpleOne[j - 2] + _vm.arrSimpleTwo[i - 2])
                        : _vm.arrSimpleThree[j - 2] +
                          _vm.arrSimpleFour[i - 2] +
                          "x" +
                          (_vm.arrSimpleOne[j - 2] + _vm.arrSimpleTwo[i - 2])))]):(
                      i === _vm.r[3] + 1 &&
                        j === _vm.c[3] + 1 &&
                        _vm.arrSimpleOne[j - 2] + _vm.arrSimpleTwo[i - 2] > 0
                    )?_c('b',[_vm._v(_vm._s(_vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === 0
                        ? _vm.arrSimpleTwo[i - 2] + _vm.arrSimpleOne[j - 2]
                        : _vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === 1
                        ? "x+" + (_vm.arrSimpleTwo[i - 2] + _vm.arrSimpleOne[j - 2])
                        : _vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === -1
                        ? "-x+" + (_vm.arrSimpleTwo[i - 2] + _vm.arrSimpleOne[j - 2])
                        : _vm.arrSimpleThree[j - 2] +
                          _vm.arrSimpleFour[i - 2] +
                          "x+" +
                          (_vm.arrSimpleTwo[i - 2] + _vm.arrSimpleOne[j - 2])))]):(
                      i === _vm.r[3] + 1 &&
                        j === _vm.c[3] + 1 &&
                        _vm.arrSimpleOne[j - 2] + _vm.arrSimpleTwo[i - 2] === 0
                    )?_c('b',[_vm._v(_vm._s(_vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === 0
                        ? 0
                        : _vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === 1
                        ? "x"
                        : _vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === -1
                        ? "-x"
                        : _vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] + "x"))]):(
                      i === _vm.r[3] + 1 &&
                        j === _vm.c[3] + 1 &&
                        _vm.arrSimpleOne[j - 2] + _vm.arrSimpleTwo[i - 2] < 0
                    )?_c('b',[_vm._v(_vm._s(_vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === 0
                        ? _vm.arrSimpleOne[j - 2] + _vm.arrSimpleTwo[i - 2]
                        : _vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === 1
                        ? "x" + (_vm.arrSimpleOne[j - 2] + _vm.arrSimpleTwo[i - 2])
                        : _vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === -1
                        ? "-x" + (_vm.arrSimpleOne[j - 2] + _vm.arrSimpleTwo[i - 2])
                        : _vm.arrSimpleThree[j - 2] +
                          _vm.arrSimpleFour[i - 2] +
                          "x" +
                          (_vm.arrSimpleOne[j - 2] + _vm.arrSimpleTwo[i - 2])))]):(
                      i === _vm.r[3] + 1 &&
                        j === _vm.c[4] + 1 &&
                        _vm.arrSimpleOne[j - 2] + _vm.arrSimpleTwo[i - 2] > 0
                    )?_c('b',[_vm._v(_vm._s(_vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === 0
                        ? _vm.arrSimpleTwo[i - 2] + _vm.arrSimpleOne[j - 2]
                        : _vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === 1
                        ? "x+" + (_vm.arrSimpleTwo[i - 2] + _vm.arrSimpleOne[j - 2])
                        : _vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === -1
                        ? "-x+" + (_vm.arrSimpleTwo[i - 2] + _vm.arrSimpleOne[j - 2])
                        : _vm.arrSimpleThree[j - 2] +
                          _vm.arrSimpleFour[i - 2] +
                          "x+" +
                          (_vm.arrSimpleTwo[i - 2] + _vm.arrSimpleOne[j - 2])))]):(
                      i === _vm.r[3] + 1 &&
                        j === _vm.c[4] + 1 &&
                        _vm.arrSimpleOne[j - 2] + _vm.arrSimpleTwo[i - 2] === 0
                    )?_c('b',[_vm._v(_vm._s(_vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === 0
                        ? 0
                        : _vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === 1
                        ? "x"
                        : _vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === -1
                        ? "-x"
                        : _vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] + "x"))]):(
                      i === _vm.r[3] + 1 &&
                        j === _vm.c[4] + 1 &&
                        _vm.arrSimpleOne[j - 2] + _vm.arrSimpleTwo[i - 2] < 0
                    )?_c('b',[_vm._v(_vm._s(_vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === 0
                        ? _vm.arrSimpleOne[j - 2] + _vm.arrSimpleTwo[i - 2]
                        : _vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === 1
                        ? "x" + (_vm.arrSimpleOne[j - 2] + _vm.arrSimpleTwo[i - 2])
                        : _vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === -1
                        ? "-x" + (_vm.arrSimpleOne[j - 2] + _vm.arrSimpleTwo[i - 2])
                        : _vm.arrSimpleThree[j - 2] +
                          _vm.arrSimpleFour[i - 2] +
                          "x" +
                          (_vm.arrSimpleOne[j - 2] + _vm.arrSimpleTwo[i - 2])))]):(
                      i === _vm.r[4] + 1 &&
                        j === _vm.c[4] + 1 &&
                        _vm.arrSimpleOne[j - 2] + _vm.arrSimpleTwo[i - 2] > 0
                    )?_c('b',[_vm._v(_vm._s(_vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === 0
                        ? _vm.arrSimpleTwo[i - 2] + _vm.arrSimpleOne[j - 2]
                        : _vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === 1
                        ? "x+" + (_vm.arrSimpleTwo[i - 2] + _vm.arrSimpleOne[j - 2])
                        : _vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === -1
                        ? "-x+" + (_vm.arrSimpleTwo[i - 2] + _vm.arrSimpleOne[j - 2])
                        : _vm.arrSimpleThree[j - 2] +
                          _vm.arrSimpleFour[i - 2] +
                          "x+" +
                          (_vm.arrSimpleTwo[i - 2] + _vm.arrSimpleOne[j - 2])))]):(
                      i === _vm.r[4] + 1 &&
                        j === _vm.c[4] + 1 &&
                        _vm.arrSimpleOne[j - 2] + _vm.arrSimpleTwo[i - 2] === 0
                    )?_c('b',[_vm._v(_vm._s(_vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === 0
                        ? 0
                        : _vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === 1
                        ? "x"
                        : _vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === -1
                        ? "-x"
                        : _vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] + "x"))]):(
                      i === _vm.r[4] + 1 &&
                        j === _vm.c[4] + 1 &&
                        _vm.arrSimpleOne[j - 2] + _vm.arrSimpleTwo[i - 2] < 0
                    )?_c('b',[_vm._v(_vm._s(_vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === 0
                        ? _vm.arrSimpleOne[j - 2] + _vm.arrSimpleTwo[i - 2]
                        : _vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === 1
                        ? "x" + (_vm.arrSimpleOne[j - 2] + _vm.arrSimpleTwo[i - 2])
                        : _vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === -1
                        ? "-x" + (_vm.arrSimpleOne[j - 2] + _vm.arrSimpleTwo[i - 2])
                        : _vm.arrSimpleThree[j - 2] +
                          _vm.arrSimpleFour[i - 2] +
                          "x" +
                          (_vm.arrSimpleOne[j - 2] + _vm.arrSimpleTwo[i - 2])))]):(
                      i === _vm.r[4] + 1 &&
                        j === _vm.c[5] + 1 &&
                        _vm.arrSimpleOne[j - 2] + _vm.arrSimpleTwo[i - 2] > 0
                    )?_c('b',[_vm._v(_vm._s(_vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === 0
                        ? _vm.arrSimpleTwo[i - 2] + _vm.arrSimpleOne[j - 2]
                        : _vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === 1
                        ? "x+" + (_vm.arrSimpleTwo[i - 2] + _vm.arrSimpleOne[j - 2])
                        : _vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === -1
                        ? "-x+" + (_vm.arrSimpleTwo[i - 2] + _vm.arrSimpleOne[j - 2])
                        : _vm.arrSimpleThree[j - 2] +
                          _vm.arrSimpleFour[i - 2] +
                          "x+" +
                          (_vm.arrSimpleTwo[i - 2] + _vm.arrSimpleOne[j - 2])))]):(
                      i === _vm.r[4] + 1 &&
                        j === _vm.c[5] + 1 &&
                        _vm.arrSimpleOne[j - 2] + _vm.arrSimpleTwo[i - 2] === 0
                    )?_c('b',[_vm._v(_vm._s(_vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === 0
                        ? 0
                        : _vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === 1
                        ? "x"
                        : _vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === -1
                        ? "-x"
                        : _vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] + "x"))]):(
                      i === _vm.r[4] + 1 &&
                        j === _vm.c[5] + 1 &&
                        _vm.arrSimpleOne[j - 2] + _vm.arrSimpleTwo[i - 2] < 0
                    )?_c('b',[_vm._v(_vm._s(_vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === 0
                        ? _vm.arrSimpleOne[j - 2] + _vm.arrSimpleTwo[i - 2]
                        : _vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === 1
                        ? "x" + (_vm.arrSimpleOne[j - 2] + _vm.arrSimpleTwo[i - 2])
                        : _vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === -1
                        ? "-x" + (_vm.arrSimpleOne[j - 2] + _vm.arrSimpleTwo[i - 2])
                        : _vm.arrSimpleThree[j - 2] +
                          _vm.arrSimpleFour[i - 2] +
                          "x" +
                          (_vm.arrSimpleOne[j - 2] + _vm.arrSimpleTwo[i - 2])))]):(
                      i === _vm.r[5] + 1 &&
                        j === _vm.c[5] + 1 &&
                        _vm.arrSimpleOne[j - 2] + _vm.arrSimpleTwo[i - 2] > 0
                    )?_c('b',[_vm._v(_vm._s(_vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === 0
                        ? _vm.arrSimpleTwo[i - 2] + _vm.arrSimpleOne[j - 2]
                        : _vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === 1
                        ? "x+" + (_vm.arrSimpleTwo[i - 2] + _vm.arrSimpleOne[j - 2])
                        : _vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === -1
                        ? "-x+" + (_vm.arrSimpleTwo[i - 2] + _vm.arrSimpleOne[j - 2])
                        : _vm.arrSimpleThree[j - 2] +
                          _vm.arrSimpleFour[i - 2] +
                          "x+" +
                          (_vm.arrSimpleTwo[i - 2] + _vm.arrSimpleOne[j - 2])))]):(
                      i === _vm.r[5] + 1 &&
                        j === _vm.c[5] + 1 &&
                        _vm.arrSimpleOne[j - 2] + _vm.arrSimpleTwo[i - 2] === 0
                    )?_c('b',[_vm._v(_vm._s(_vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === 0
                        ? 0
                        : _vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === 1
                        ? "x"
                        : _vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === -1
                        ? "-x"
                        : _vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] + "x"))]):(
                      i === _vm.r[5] + 1 &&
                        j === _vm.c[5] + 1 &&
                        _vm.arrSimpleOne[j - 2] + _vm.arrSimpleTwo[i - 2] < 0
                    )?_c('b',[_vm._v(_vm._s(_vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === 0
                        ? _vm.arrSimpleOne[j - 2] + _vm.arrSimpleTwo[i - 2]
                        : _vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === 1
                        ? "x" + (_vm.arrSimpleOne[j - 2] + _vm.arrSimpleTwo[i - 2])
                        : _vm.arrSimpleThree[j - 2] + _vm.arrSimpleFour[i - 2] === -1
                        ? "-x" + (_vm.arrSimpleOne[j - 2] + _vm.arrSimpleTwo[i - 2])
                        : _vm.arrSimpleThree[j - 2] +
                          _vm.arrSimpleFour[i - 2] +
                          "x" +
                          (_vm.arrSimpleOne[j - 2] + _vm.arrSimpleTwo[i - 2])))]):(i === 1 && j !== 1)?_c('b',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inputNum[i * 10 + j]),expression:"inputNum[i * 10 + j]"}],ref:i * 10 + j,refInFor:true,staticStyle:{"width":"5vw","height":"5vw","background":"rgba(165, 220, 255, 1)","border":"0px"},attrs:{"type":"text"},domProps:{"value":(_vm.inputNum[i * 10 + j])},on:{"keyup":function($event){return _vm.checkNum(i, j, _vm.inputNum[i * 10 + j])},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.inputNum, i * 10 + j, $event.target.value)}}})]):(j === 1 && i !== 1)?_c('b',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inputNum[i * 10 + j]),expression:"inputNum[i * 10 + j]"}],ref:i * 10 + j,refInFor:true,staticStyle:{"width":"5vw","height":"5vw","background":"rgba(165, 220, 255, 1)","border":"0px"},attrs:{"type":"text"},domProps:{"value":(_vm.inputNum[i * 10 + j])},on:{"keyup":function($event){return _vm.checkNum(i, j, _vm.inputNum[i * 10 + j])},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.inputNum, i * 10 + j, $event.target.value)}}})]):_c('b',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inputNum[i * 10 + j]),expression:"inputNum[i * 10 + j]"}],ref:i * 10 + j,refInFor:true,staticStyle:{"width":"5vw","height":"5vw","border":"0px"},attrs:{"type":"text"},domProps:{"value":(_vm.inputNum[i * 10 + j])},on:{"input":[function($event){if($event.target.composing){ return; }_vm.$set(_vm.inputNum, i * 10 + j, $event.target.value)},function($event){return _vm.checkNum(i, j, _vm.inputNum[i * 10 + j])}]}})])])}),0)}),0)])]),_c('div',{ref:"qqq",staticClass:"col-12 col-md-6 app--lesson-right",staticStyle:{"padding-left":"200px","overflow":"visible","max-width":"50%"}},[_c('div',[_c('div',{staticStyle:{"max-width":"15%","font-size":"1vw","color":"#0f0f0f","position":"relative"}},[_c('br'),_c('br'),_c('br'),_c('br'),_c('br'),_c('br'),_c('br'),_c('br'),_c('br'),_c('div',{staticStyle:{"min-width":"500px","height":"400px","margin":"0 auto"},style:({ visibility: _vm.isChecked ? 'visible' : 'hidden' }),attrs:{"id":"container"}},[_c('div',[_c('h5',[_vm._v("Graph")]),_c('highcharts-container',{attrs:{"defOptions":_vm.ops,"styles":_vm.sty}})],1)])])])])])])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }